export default __webpack_public_path__ + "static/media/plus.f7f330ce.svg";